/**
 * Enum representing all possible keys used in bunkeringInputFields
 * These keys are used to access properties on the Bunkering object and for validation
 */
export enum BUNKERING_INPUT_FIELD_KEYS {
    // Basic bunkering information
    BDN_REFERENCE = 'bdnReference',
    FUEL_TYPE = 'fuelType',
    TOTAL_RECEIVED_QUANTITY = 'totalReceivedQuantity',

    // Fuel properties
    SULPHUR = 'sulphur',
    FUEL_VISCOSITY = 'fuelViscosity',
    BDN_LITER_WEIGHT = 'bdnLiterWeight',
    FTA_LITER_WEIGHT = 'ftaLiterWeight',
    WATER_CONTENT = 'waterContent',

    // Bio fuel related fields
    BIO_BLEND_FOSSIL_FUEL_TYPE = 'bioBlendFossilFuelType',
    BIO_FUEL_TYPE = 'bioFuelType',
    BIO_BLEND = 'bioBlend',
    BIOFUEL_VOLUME = 'biofuelVolume',
    BIOFUEL_MASS = 'biofuelMass',
    BIOFUEL_ENERGY_CONTENT = 'biofuelEnergyContent',
    BIOFUEL_GRADE = 'biofuelGrade',

    // Sustainability and emissions
    LOWER_HEATING_VALUE = 'lowerHeatingValue',
    EU_LOWER_CALORIFIC_VALUE = 'euLowerCalorificValue',
    EU_GHG_EMISSIONS = 'euGhgEmissions',
    IMO_GHG_EMISSIONS = 'imoGhgEmissions',
    SUSTAINABILITY_REFERENCE = 'sustainabilityReference',
}
